import React, { useEffect, useState } from 'react'
import TextField from '../../../core/common/textFields/TextField'
import { svgIcons } from '../../../style/fonts/SvgIcons'
import { InputMask } from '@react-input/mask'
import { options1 } from '../../../core/common/selectoption/selectoption'
import Select, { StylesConfig } from "react-select";
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link, useNavigate, useParams } from 'react-router-dom'
import FilterComponent from '../../../core/common/FilterComponent'
import { useCreateAccountMutation, useCreateContactMutation, useGetAccountContactsLookupQuery, useGetContactsByAccountIdQuery } from '../../../services/EndPointsApis'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import ContactsSidebar from '../Contacts/ContactsSidebar'
import { inputMaskNumber } from '../../../core/common/textFields/NumberField'

const SummaryTab = ({ isReadOnly, isEditing, formik, useAccountById, AccountName, AccountId, refetchContactsLookup, getContacts, getContactsLookup }: any) => {
    type TeamOption = {
        label: number;
        value: string;
    };
    const [contactsidebarOpen, setContactsidebarOpen] = useState(false);
    const [createContact, { data, isError, error, isSuccess, isLoading }] =
        useCreateContactMutation();
    const navigate = useNavigate();

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    const options = isEditing || isReadOnly
        ? getContacts?.result?.accountContacts?.map((option: any) => ({
            label: option?.firstName,
            value: option?.id
        }))
        : getContactsLookup?.result?.map((option: any) => ({
            label: option?.value,
            value: option?.id
        }));


    const closeSidebar = () => {
        setContactsidebarOpen(false);
    }

    return (
        <>
            <ContactsSidebar activityTogglePopup={contactsidebarOpen} closeSidebar={closeSidebar}
                refetchContactsLookup={refetchContactsLookup} createContact={createContact}
                error={error} isError={isError} data={data} isSuccess={isSuccess}
                AccountName={AccountName}
                AccountId={AccountId}
            />
            <div className="row">
                <div className="col-md-4">
                    <div className="card h-100">
                        <div className="card-body p-3">
                            <h5>
                                Account Information
                            </h5>
                            <div className="col-md-12">
                                <TextField
                                    label="Account Number"
                                    type="text"
                                    {...formik.getFieldProps("accountNumber")}
                                    disabled
                                    icon={svgIcons.LockIcon}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Account Name "
                                    type="text"
                                    {...formik.getFieldProps("accountName")}
                                    disabled={isReadOnly || isEditing}
                                    icon={svgIcons.LockIcon}
                                    required

                                />
                                {formik.touched.accountName && formik.errors.accountName && (
                                    <div className="error">{formik.errors.accountName}</div>
                                )}
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Originating Lead"
                                    type="text"
                                    {...formik.getFieldProps("originatingLead")}
                                    disabled
                                    icon={svgIcons.LockIcon}
                                />
                            </div>
                            <div className="col-md-12">
                                <div className="form-wrap">
                                    <label className='input-label'>
                                        Phone
                                    </label>
                                    <InputMask mask={inputMaskNumber}
                                        replacement={{ _: /\d/ }}
                                        className='form-control'
                                        {...formik.getFieldProps("phone")}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Email"
                                    type="text"
                                    {...formik.getFieldProps("email")}
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="col-md-12">
                                <div className="form-wrap">
                                    <label className='input-label'>
                                        Fax
                                    </label>
                                    <InputMask mask={inputMaskNumber}
                                        replacement={{ _: /\d/ }}
                                        className='form-control'
                                        {...formik.getFieldProps("fax")}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Document Center"
                                    type="text"
                                    {...formik.getFieldProps("documentCenter")}
                                    disabled={isReadOnly}
                                    icon={svgIcons.LockIcon}

                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Primary PDM"
                                    type="text"
                                    {...formik.getFieldProps("primaryPDM")}
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Contact Preferences"
                                    type="text"
                                    {...formik.getFieldProps("contactPreferences")}
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="col-md-6">
                                <div className="radio-wrap">
                                    <label className="input-label">Status</label>
                                    <div className="d-flex flex-wrap">
                                        <div className="radio-btn">
                                            <input
                                                type="radio"
                                                className="status-radio"
                                                id="Active"
                                                name="isActive"
                                                value="true"
                                                disabled={isReadOnly}
                                                checked={formik?.values?.isActive === true}
                                                onChange={() => formik.setFieldValue('isActive', true)}
                                            />
                                            <label htmlFor="Active">Active</label>
                                        </div>
                                        <div className="radio-btn">
                                            <input
                                                type="radio"
                                                className="status-radio"
                                                id="inActive"
                                                name="isActive"
                                                value="false"
                                                disabled={isReadOnly}
                                                checked={formik?.values?.isActive === false}
                                                onChange={() => formik.setFieldValue('isActive', false)}
                                            />
                                            <label htmlFor="inActive">Inactive</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className='card'>
                        <div className='card-body p-3'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h5 className='mb-2'>
                                    TimeLine
                                </h5>
                                <div className='d-flex gap-2'>
                                    <FilterComponent />
                                </div>
                            </div>
                            <div>
                                <div className="icon-form">
                                    <span className="form-icon">
                                        <i className="ti ti-search" />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                    // onChange={handleSearchChange}
                                    />
                                </div>
                            </div>
                            <div className="noti-content mt-2">
                                <ul className="notification-list">
                                    <li className="notification-message">
                                        <Link to='#'>
                                            <div className="media d-flex gap-3 align-items-center">
                                                <span className="avatar timeline-img flex-shrink-0">
                                                    <ImageWithBasePath
                                                        src="assets/img/profiles/profile-img.jpg"
                                                        alt="Profile"
                                                        className="timeline-img"
                                                    />
                                                    <span className="badge badge-info rounded-pill" />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <h6 className="mb-2"><span className="mb-0 me-2">{svgIcons.calendarIcon}</span>Meeting Held By Linda</h6>
                                                    <p className="noti-details mb-0">
                                                        Meeting with client & Linda
                                                    </p>
                                                    <div className="d-flex gap-2">
                                                        <p className="noti-time mt-2 mb-0">
                                                            9/29/2024
                                                        </p>
                                                        <p className="noti-time mt-2 mb-0">
                                                            03:36 PM
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <hr />
                                    <li className="notification-message">
                                        <Link to='#'>
                                            <div className="media d-flex gap-3 align-items-center">
                                                <span className="avatar timeline-img flex-shrink-0">
                                                    <ImageWithBasePath
                                                        src="assets/img/profiles/profile-img.jpg"
                                                        alt="Profile"
                                                        className="timeline-img"
                                                    />
                                                    <span className="badge badge-info rounded-pill" />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <h6 className="mb-2"><span className="mb-0 me-2">{svgIcons.calendarIcon}</span>Meeting Held By John</h6>
                                                    <p className="noti-details mb-0">
                                                        Meeting with client & John
                                                    </p>
                                                    <div className="d-flex gap-2">
                                                        <p className="noti-time mt-2 mb-0">
                                                            7/28/2024
                                                        </p>
                                                        <p className="noti-time mt-2 mb-0">
                                                            04:16 PM
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>

                            </div>
                            <hr />
                            <div className="noti-content">
                                <ul className="notification-list">
                                    <li className="notification-message">
                                        <Link to='#'>
                                            <div className="media d-flex gap-3 align-items-center">
                                                <span className="avatar timeline-img flex-shrink-0">
                                                    <ImageWithBasePath
                                                        src="assets/img/profiles/profile-img.jpg"
                                                        alt="Profile"
                                                        className="timeline-img"
                                                    />
                                                    <span className="badge badge-info rounded-pill" />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <h6 className="mb-2"><span className="mb-0 me-2">{svgIcons.calendarIcon}</span>Meeting Held By smith</h6>
                                                    <p className="noti-details mb-0">
                                                        Meeting with client & smith
                                                    </p>
                                                    <div className="d-flex gap-2">
                                                        <p className="noti-time mt-2 mb-0">
                                                            10/29/2024
                                                        </p>
                                                        <p className="noti-time mt-2 mb-0">
                                                            05:32 PM
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <hr />
                                    <li className="notification-message">
                                        <Link to='#'>
                                            <div className="media d-flex gap-3 align-items-center">
                                                <span className="avatar timeline-img flex-shrink-0">
                                                    <ImageWithBasePath
                                                        src="assets/img/profiles/profile-img.jpg"
                                                        alt="Profile"
                                                        className="timeline-img"
                                                    />
                                                    <span className="badge badge-info rounded-pill" />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <h6 className="mb-2"><span className="mb-0 me-2">{svgIcons.calendarIcon}</span>Meeting Held By Michael</h6>
                                                    <p className="noti-details mb-0">
                                                        Meeting with client & Michael
                                                    </p>
                                                    <div className="d-flex gap-2">
                                                        <p className="noti-time mt-2 mb-0">
                                                            12/19/2024
                                                        </p>
                                                        <p className="noti-time mt-2 mb-0">
                                                            02:12 PM
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='card'>
                        <div className='card-body'>
                            <h5 className='mb-2'>
                                Primary Contact
                            </h5>
                            <div className="col-md-12">
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={options}
                                    value={
                                        formik.values?.lst_PrimaryContact
                                            ? {
                                                value: formik.values?.lst_PrimaryContact?.id,
                                                label: formik.values?.lst_PrimaryContact?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_PrimaryContact.id', selectedOption.value);
                                        formik.setFieldValue('lst_PrimaryContact.value', selectedOption.label);
                                    }}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Email"
                                    type="text"
                                    {...formik.getFieldProps("primaryContactEmail")}
                                    disabled
                                    icon={svgIcons.LockIcon}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Business"
                                    type="text"
                                    // {...formik.getFieldProps("workEmail")}
                                    disabled
                                    icon={svgIcons.LockIcon}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='d-flex justify-content-between'>
                                        <h4 className='mb-3'>
                                            Contacts
                                        </h4>
                                        <button disabled={isEditing || isReadOnly} className='cursor-pointer border-0 p-2 rounded-circle btn btn-transparent' onClick={(e) => {
                                            e.stopPropagation();
                                            setContactsidebarOpen(true)
                                        }} >
                                            <i className='fa fa-plus color-red fs-18'></i>
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </> */}
                    <>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='d-flex justify-content-between'>
                                    <h4 className='mb-3'>
                                        Contacts
                                    </h4>
                                    <button className='cursor-pointer border-0 p-2 rounded-circle btn btn-transparent' onClick={(e) => {
                                        e.stopPropagation();
                                        setContactsidebarOpen(true)
                                    }} >
                                        <i className='fa fa-plus color-red fs-18'></i>
                                    </button>
                                </div>
                                {getContacts?.result?.accountContacts?.map((option: any) => (
                                    <div className='d-flex gap-2 align-items-center' key={option?.id}>
                                        <div className='rounded-circle p-1 h25-w25 bg-pink text-white d-flex align-items-center justify-content-center'>
                                            {option?.firstName?.charAt(0) /* Display the first letter of the first name */}
                                        </div>
                                        <div>
                                            <b className='mb-0'>
                                                {`${option?.firstName} ${option?.lastName}`} {/* Display full name */}
                                            </b>
                                            <p className='mb-0'>
                                                {option?.email} {/* Display email */}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                </div>

            </div>
        </>
    )
}

export default SummaryTab